<template>
	<pre v-html="$t('terms.legal_indication5')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication5',
};
</script>

<style scoped></style>
